
import { Product, Group } from "@/lib/types";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import ProductUsageItem from "./ProductUsageItem";

interface UsageProductListProps {
  product?: Product;
  group?: Group;
  products: Product[];
  selectedProducts: {id: string, quantity: number}[];
  handleQuantityChange: (id: string, quantity: number) => void;
  handleToggleProduct: (id: string, checked: boolean) => void;
}

const UsageProductList = ({ 
  product, 
  group, 
  products, 
  selectedProducts, 
  handleQuantityChange, 
  handleToggleProduct 
}: UsageProductListProps) => {
  const getSelectedItem = (id: string) => {
    return selectedProducts.find(item => item.id === id);
  };

  return (
    <div className="space-y-3">
      <Label>Products Used</Label>
      <div className="border rounded-md p-3 space-y-3 max-h-[300px] overflow-y-auto">
        {product ? (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">{product.name}</span>
              <Input
                type="number"
                min="1"
                className="w-20 h-8 text-sm"
                value={selectedProducts[0]?.quantity || 1}
                onChange={(e) => handleQuantityChange(product.id, Number(e.target.value))}
                inputMode="numeric"
                pattern="[0-9]*"
              />
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Current stock: {product.currentStock} units
            </p>
          </div>
        ) : (
          <>
            {group ? (
              // Show products from the group
              products
                .filter(p => group.productIds.includes(p.id))
                .map(p => {
                  const selectedItem = getSelectedItem(p.id);
                  return (
                    <ProductUsageItem
                      key={p.id}
                      product={p}
                      isSelected={!!selectedItem}
                      quantity={selectedItem?.quantity || 1}
                      onToggle={handleToggleProduct}
                      onQuantityChange={handleQuantityChange}
                    />
                  );
                })
            ) : (
              // Show all products
              products.map(p => {
                const selectedItem = getSelectedItem(p.id);
                return (
                  <ProductUsageItem
                    key={p.id}
                    product={p}
                    isSelected={!!selectedItem}
                    quantity={selectedItem?.quantity || 1}
                    onToggle={handleToggleProduct}
                    onQuantityChange={handleQuantityChange}
                  />
                );
              })
            )}
          </>
        )}
        
        {selectedProducts.length === 0 && (
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Select at least one product
          </p>
        )}
      </div>
    </div>
  );
};

export default UsageProductList;
